module.exports = __webpack_public_path__ + "static/media/logo-price-homologation.a197cf5a.svg";